var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9657 9.82906C9.78666 10.0153 9.5575 10.1495 9.2782 10.2319C8.9989 10.3142 8.76615 10.2623 8.57996 10.0761C8.40092 9.89709 8.3114 9.59094 8.3114 9.15767C8.3114 8.7244 8.40092 8.41825 8.57996 8.23922L10.4169 6.41304H1.24304C0.985229 6.41304 0.768595 6.3289 0.59314 6.1606C0.417684 5.99231 0.329956 5.77925 0.329956 5.52144C0.329956 5.26363 0.417684 5.04162 0.59314 4.85543C0.768595 4.66923 0.985229 4.57613 1.24304 4.57613H10.4169L8.57996 2.73922C8.40092 2.56018 8.3114 2.25582 8.3114 1.82613C8.3114 1.39644 8.40092 1.09208 8.57996 0.913044C8.76615 0.726846 8.9989 0.683877 9.2782 0.784138C9.5575 0.884398 9.78666 1.02405 9.9657 1.20308L13.7792 4.86617C13.8651 4.94494 13.9331 5.04162 13.9833 5.15621C14.0334 5.27079 14.0585 5.39254 14.0585 5.52144C14.0585 5.64319 14.0334 5.76135 13.9833 5.87593C13.9331 5.99052 13.8651 6.0872 13.7792 6.16597L9.9657 9.82906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.961f8764f8df9c42b59cd031d5a200c7.svg";
export { ForwardRef as ReactComponent };